import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-326deee2")

_pushScopeId("data-v-326deee2")
const _hoisted_1 = { class: "work-record-application" }
const _hoisted_2 = { class: "font-bold text-2xl mb-8" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-close text-2xl" }, null, -1)
const _hoisted_4 = { class: "work-record-table" }
const _hoisted_5 = { class: "mb-8" }
const _hoisted_6 = { class: "font-bold mb-1" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "divider-light-blue mb-4" }, null, -1)
const _hoisted_8 = { class: "text-base flex items-center" }
const _hoisted_9 = { class: "ml-2" }
const _hoisted_10 = { class: "mb-8" }
const _hoisted_11 = { class: "font-bold mb-1" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "divider-light-blue mb-4" }, null, -1)
const _hoisted_13 = { class: "" }
const _hoisted_14 = { class: "font-bold text-sm" }
const _hoisted_15 = { class: "flex items-center" }
const _hoisted_16 = { class: "ml-2" }
const _hoisted_17 = { class: "mt-4" }
const _hoisted_18 = { class: "font-bold text-sm" }
const _hoisted_19 = { class: "" }
const _hoisted_20 = { class: "mb-4" }
const _hoisted_21 = { class: "font-bold mb-1" }
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "divider-light-blue" }, null, -1)
const _hoisted_23 = { class: "" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_BackPreviousPage = _resolveComponent("BackPreviousPage")
  const _component_Button = _resolveComponent("Button")
  const _component_ReasonUpdateStatusApplication = _resolveComponent("ReasonUpdateStatusApplication")
  const _component_ApplicationApproveFlowDetail = _resolveComponent("ApplicationApproveFlowDetail")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_BackPreviousPage, { onClick: _ctx.returnScreen }, null, 8, ["onClick"]),
      _createVNode("div", _hoisted_2, _toDisplayString(_ctx.t('workRecordApplicationCheckTime')), 1),
      (_ctx.isTypeStatusApplication)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            class: "font-normal my-3",
            variant: "outline-primary",
            onClick: _ctx.handleTypeFinished
          }, {
            default: _withId(() => [
              _hoisted_3,
              _createTextVNode(_toDisplayString(_ctx.t('deleteAchievement')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, _toDisplayString(_ctx.t('overtimeRegister.targetDate')), 1),
          _hoisted_7,
          _createVNode("div", _hoisted_8, [
            _createTextVNode(_toDisplayString(_ctx.targetDate) + " ", 1),
            _createVNode("div", _hoisted_9, "(" + _toDisplayString(_ctx.t('month')) + ")", 1)
          ])
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, _toDisplayString(_ctx.t('applicationApprovalContent.title')), 1),
          _hoisted_12,
          _createVNode("div", _hoisted_13, [
            _createVNode("div", _hoisted_14, _toDisplayString(_ctx.t('timeCardNew.numberOfWaits')), 1),
            _createVNode("div", _hoisted_15, [
              _createTextVNode(_toDisplayString(_ctx.dataRecordApplication.wait_numbers) + " ", 1),
              _createVNode("div", _hoisted_16, _toDisplayString(_ctx.t('times')), 1)
            ])
          ]),
          _createVNode("div", _hoisted_17, [
            _createVNode("div", _hoisted_18, _toDisplayString(_ctx.t('attendanceOrganization')), 1),
            _createVNode("div", _hoisted_19, _toDisplayString(_ctx.dataRecordApplication.checkin_unit_name), 1)
          ])
        ]),
        _createVNode("div", _hoisted_20, [
          _createVNode("div", _hoisted_21, _toDisplayString(_ctx.t('overtimeRegister.ReasonApplication')), 1),
          _hoisted_22,
          _createVNode("div", _hoisted_23, _toDisplayString(_ctx.dataRecordApplication.application_reason), 1)
        ])
      ]),
      _createVNode(_component_ReasonUpdateStatusApplication, { status: _ctx.statusApplication }, null, 8, ["status"])
    ]),
    _createVNode(_component_ApplicationApproveFlowDetail, {
      status: _ctx.statusApplication,
      createdAt: _ctx.createdAt
    }, null, 8, ["status", "createdAt"])
  ], 64))
})